import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import Loader from "../../Components/Loader/Loader";
import AiLeadsAction from "../../Components/AiLeads/AiLeadsButton/AiLeadsAction";
import OrganizationList from "../../Components/FavoritesList/FavoritesOrganizationList/OrganizationList";
import PeopleList from "../../Components/FavoritesList/FavoritesPeopleList/PeopleList";
import SharedOrganizationList from "../../Components/FavoritesList/FavoritesOrganizationList/SharedOrganizationList";
import SharedPeopleList from "../../Components/FavoritesList/FavoritesPeopleList/SharedPeopleList";
import { APIDataUrl, APITokenUrl, GetUserId } from "../../Utils/Utils";
import { useLocation } from "react-router-dom";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import axios from "axios";
import OrganizationPeopleSearch from "../../Components/FavoritesList/FavoritesOrganizationList/OrganizationPeopleSearch";
import OrganizationPeopleSearchShared from "../../Components/FavoritesList/FavoritesOrganizationList/OrganizationPeopleSearchShared";
import moment from "moment";
import MessageModal from "../../Components/MessageModal/MessageModal";
import ProspectRequestModal from "../../Components/RequestUpdateModals/ProspectRequestModal";
import LeadsProspectModal from "../../Components/RequestUpdateModals/LeadsProspectModal";
import OrganizationPeopleSearchSharedNew from "../../Components/FavoritesList/FavoritesPeopleList/OrganizationPeopleSearchSharedNew";
import OrganizationPeopleSearchNew from "../../Components/FavoritesList/FavoritesPeopleList/OrganizationPeopleSearchNew";
import SalesForceMessageModal from "../../Components/MessageModal/SalesForceMessageModal";
import { Box, Modal } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import AddIcon from "@mui/icons-material/Add";

const FavoritesList = () => {
  const [loading, setLoading] = useState(false);
  const [activeList, setActiveList] = useState("myList");
  const [activeSearch, setActiveSearch] = useState("organization");
  const [activeSearchPeople, setActiveSearchPeople] = useState("people");
  const [searchResultOrganization, setSearchResultOrganization] = useState();
  const [searchResultPeople, setSearchResultPeople] = useState();
  const [dummyorg, setDummyOrg] = useState();
  const [messageModalSalesforce, setMessageModalSalesforce] =
    React.useState(false);
  const [innerDataNew, setInnerDataNew] = useState([]);
  const [headerSearchData, setheaderSearchData] = React.useState("");
  const [headerSearchDataPeople, setheaderSearchDataPeople] =
    React.useState("");
  const [responseData, setResponseData] = React.useState(null);
  const [favoriteSearchData, setFavoriteSearchData] = useState();
  const location = useLocation();
  const [archiveRecord, setArchiveRecord] = React.useState(false);
  const [trackRecord, setTrackRecord] = React.useState(false);
  const [requestUpdateRecord, setRequestUpdateRecord] = useState(false);
  const [disableRequestUpdate, setDisableRequestUpdate] = useState(false);
  const [isSalesForceTrigger, setIsSalesForceTrigger] = useState(false);
  const [showSalesForce, setShowSalesForce] = useState(false);
  const [isDecisionMakerExcel, setIsDecisionMakerExcel] = useState(false);
  const [isDecisionMakerExcelList, setIsDecisionMakerExcelList] =
    useState(false);
  const [selectedLeadsModal, setSelectedLeadsModal] = useState(false);
  const [selectedProspectsModal, setSelectedProspectsModal] = useState(false);
  const [showLeadsProspects, setShowLeadsProspects] = useState("");
  const loggedInUserId = GetUserId();
  const [selectedProspectsInner, setSelectedProspectsInner] = React.useState(
    [],
  );
  // for organization tracking
  const [shareRecord, setShareRecord] = React.useState(false);
  const [retrieveData, setRetrieveData] = React.useState(false);
  const [showSearchdata, setshowSearchdata] = React.useState(false);
  const [trackingData, setTrackingData] = useState([]);
  const [disableTracking, setDisableTracking] = useState(false);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [totalCount, setTotalCount] = React.useState(0);
  const [addToFav, setAddToFav] = useState(false);
  const [archiveMessageModal, setArchiveMessageModal] = useState(false);
  const [requestUpdateModal, setRequestUpdateModal] = React.useState(false);
  const [messageModalTrack, setMessageModalTrack] = React.useState(false);
  const [removeFavModal, setRemoveFavModal] = React.useState(false);

  //for OrganizationList
  const [selectedOrganizationList, setSelectedOrganizationList] = useState([]);

  //for organization Table
  const [selectedOrganizationData, setSelectedOrganizationData] = useState([]);

  //disable
  const [disableOrganizationList, setDisableOrganizationList] = useState(false);
  const [disableOrganizationData, setDisableOrganizationData] = useState(false);

  //for prospectList
  const [selectedProspectList, setSelectedProspectList] = useState([]);
  //for prospect Table
  const [selectedProspectData, setSelectedProspectData] = useState([]);

  //disable
  const [disableProspectList, setDisableProspectList] = useState(false);
  const [disableProspectData, setDisableProspectData] = useState(false);
  const [favoriteListMenuShow, setFavoriteListMenuShow] = useState(false);
  const [isDeleteRecord, setIsDeleteRecord] = useState(false);
  const [isDeleteRecordOrg, setIsDeleteRecordOrg] = useState(false);

  const [openRowId, setopenRowId] = useState("");
  const [organizationListRecords, setOrganizationListRecords] = useState("");
  const [prospectsListRecords, setProspectsListRecords] = useState("");
  useEffect(() => {
    localStorage.removeItem("cns");
    localStorage.removeItem("cip");
    localStorage.removeItem("cdp");
  }, []);
  useEffect(() => {
    if (selectedOrganizationList?.length) {
      setDisableProspectData(true);
      setDisableProspectList(true);
      setDisableOrganizationData(true);
      setDisableOrganizationList(false);
    } else if (selectedProspectList?.length) {
      setDisableProspectData(true);
      setDisableProspectList(false);
      setDisableOrganizationList(true);
      setDisableOrganizationData(true);
    } else if (selectedOrganizationData?.length) {
      setDisableProspectData(true);
      setDisableProspectList(true);
      setDisableOrganizationList(true);
      setDisableOrganizationData(false);
    } else if (selectedProspectData?.length) {
      setDisableProspectData(false);
      setDisableProspectList(true);
      setDisableOrganizationList(true);
      setDisableOrganizationData(true);
    } else {
      setDisableProspectData(false);
      setDisableProspectList(false);
      setDisableOrganizationList(false);
      setDisableOrganizationData(false);
    }
  }, [
    selectedOrganizationList,
    selectedOrganizationData,
    selectedProspectList,
    selectedProspectData,
  ]);

  useEffect(() => {
    if (selectedOrganizationData?.length || selectedProspectData?.length) {
      setFavoriteListMenuShow(true);
    } else {
      setFavoriteListMenuShow(false);
    }
  }, [
    selectedOrganizationList,
    selectedOrganizationData,
    selectedProspectList,
    selectedProspectData,
  ]);

  const handleShare = (data) => {
    let start = window.location.origin;
    let end = window.location.pathname?.split("/");
    let href = `${start}/${end[1]}`;
    const subject = encodeURIComponent(`Link to Favorite Lists`);
    let profilesInfo = data
      .map(
        (row) =>
          `List Name: ${row?.name}\nCreated At: ${moment(
            row?.created_date,
          ).format("YYYY-MM-DD")}\nOwner: ${
            row?.first_name
              ? row.first_name.charAt(0).toUpperCase() + row.first_name.slice(1)
              : "-"
          } ${
            row?.last_name
              ? row.last_name.charAt(0).toUpperCase() + row.last_name.slice(1)
              : "-"
          }`,
      )
      .join("\n\n");
    const body = encodeURIComponent(
      `Hello,\n\nHere's Favorite Lists on Orbit Intel that you may find interesting:\n\n${profilesInfo}\n\nTo view it, log into your Orbit account and navigate to Favorites and go to the shared lists: ${href}`,
    );
    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=${subject}&body=${body}`;
    window.open(gmailLink, "_blank");
    setSelectedOrganizationList([]);
    setSelectedProspectList([]);
    setShareRecord(false);
  };

  useEffect(() => {
    if (shareRecord) {
      if (!selectedOrganizationList?.length && !selectedProspectList?.length) {
        toast.error("Please select records to share.");
        setShareRecord(false);
        return;
      }
      const hasPrivateOrg = selectedOrganizationList?.some(
        (i) => i.is_private === true,
      );
      const hasPrivateProspect = selectedProspectList?.some(
        (i) => i.is_private === true,
      );

      if (hasPrivateOrg || hasPrivateProspect) {
        toast.error("Selected records must be made public before sharing.");
        setShareRecord(false);
        return;
      }

      if (selectedOrganizationList?.length) {
        handleShare(selectedOrganizationList);
      } else {
        handleShare(selectedProspectList);
      }
    }
  }, [shareRecord]);

  React.useEffect(() => {
    if (isDecisionMakerExcel) {
      if (!selectedOrganizationData?.length && !selectedProspectData.length) {
        toast.error("Please select records to download");
        setIsDecisionMakerExcel(false);
        return;
      }
      if (selectedOrganizationData?.length) {
        exportToExcel(selectedOrganizationData, "favoritelist_exported_data");
      } else {
        exportToExcel(selectedProspectData, "favoritelist_exported_data");
      }
    }
  }, [isDecisionMakerExcel]);
  const exportToExcel = (data, filename) => {
    const filteredData = data.map((i) => ({
      ...i?.organization_details,
      ...i?.people_details,
      ...i?.user_favourite_list,
    }));
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${filename}.xlsx`);
    setIsDecisionMakerExcel(false);
  };

  React.useEffect(() => {
    if (archiveRecord == true) {
      if (!selectedOrganizationData?.length && !selectedProspectData.length) {
        toast.error("Please select records to archive");
        setArchiveRecord(false);
        return;
      }
      setArchiveMessageModal(true);
      setArchiveRecord(false);
      // handleArchiveRecords()
    }
  }, [archiveRecord]);

  const handleArchiveRecords = async () => {
    setLoading(true);
    let data;
    if (selectedOrganizationData.length) {
      data = selectedOrganizationData.map((item) => ({
        user_id: Number(GetUserId()),
        org_id: item?.organization_details?.org_id,
      }));
    } else {
      data = selectedProspectData.map((item) => ({
        user_id: Number(GetUserId()),
        person_id: item?.people_details?.person_id,
      }));
    }
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/send_archive`,
    };
    try {
      const response = await axios(options);
      setArchiveRecord(false);
      setArchiveMessageModal(false);
      setSelectedOrganizationData([]);
      setSelectedProspectData([]);
      if (response?.data?.message === "Already archived") {
        toast.success(" Already archived.");
      } else {
        toast.success(" Archived successfully.");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(
        error?.response?.data?.message || "Failed to archive organization.",
      );
    }
  };

  React.useEffect(() => {
    if (
      selectedProspectData?.length < 1 &&
      selectedOrganizationData?.length < 1 &&
      requestUpdateRecord == true
    ) {
      setDisableRequestUpdate(false);
      setRequestUpdateRecord(false);
      toast.error("Please select record to request update");
      return;
    } else if (
      selectedProspectData?.length === 1 &&
      requestUpdateRecord == true
    ) {
      setRequestUpdateModal(true);
      setRequestUpdateRecord(false);
      setDisableRequestUpdate(false);
    } else if (
      selectedOrganizationData?.length === 1 &&
      requestUpdateRecord == true
    ) {
      setRequestUpdateModal(true);
      setRequestUpdateRecord(false);
      setDisableRequestUpdate(false);
    } else if (
      selectedProspectData?.length > 1 &&
      requestUpdateRecord == true
    ) {
      setDisableRequestUpdate(false);
      setRequestUpdateRecord(false);
      toast.error("Please select only one record to request update");
    } else if (
      selectedOrganizationData?.length > 1 &&
      requestUpdateRecord == true
    ) {
      setDisableRequestUpdate(false);
      setRequestUpdateRecord(false);
      toast.error("Please select only one record to request update");
    } else {
      setDisableRequestUpdate(false);
    }
  }, [selectedProspectData, selectedOrganizationData, requestUpdateRecord]);

  const handleTrackRecords = () => {
    setLoading(true);
    let filteredData;
    if (selectedOrganizationData?.length) {
      filteredData = selectedOrganizationData.filter(
        (selectedItem) =>
          !trackingData.some(
            (trackingItem) =>
              Number(selectedItem.organization_details.org_id) ===
              Number(trackingItem.org_id),
          ),
      );
    } else {
      filteredData = selectedProspectData.filter(
        (selectedItem) =>
          !trackingData.some(
            (trackingItem) =>
              Number(selectedItem.people_details.person_id) ===
              Number(trackingItem.person_id),
          ),
      );
    }
    if (filteredData.length === 0) {
      toast.error("All selected records are already tracked.");
      setLoading(false);
      return;
    }
    const data = selectedOrganizationData?.length
      ? filteredData.map((item) => item?.organization_details.org_id)
      : filteredData.map((item) => item?.people_details.person_id);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/${
        selectedOrganizationData?.length
          ? "save_tracking_organization"
          : "save_tracking_prospect"
      }?user_id=${Number(GetUserId())}`,
    };
    axios(option)
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          toast.success("Tracking Added");
          setTrackRecord(false);
          setMessageModalTrack(false);
          setSelectedOrganizationData([]);
          setSelectedProspectData([]);
          setDisableTracking(true);
          handleTrackingdata();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };
  const handleTrackingdata = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()} /v1/get_tracking ? user_id = ${Number(
        GetUserId(),
      )} `,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = e?.data?.data;
        setTrackingData(data);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    handleTrackingdata();
  }, []);
  React.useEffect(() => {
    if (trackRecord == true) {
      if (!selectedProspectData?.length && !selectedOrganizationData?.length) {
        toast.error("Please select records to track");
        setTrackRecord(false);
        return;
      }
      setMessageModalTrack(true);
      setTrackRecord(false);
    }
  }, [trackRecord]);
  useEffect(() => {
    if (
      trackingData.length > 0 &&
      selectedProspectData.length > 0 &&
      selectedOrganizationData.length > 0
    ) {
      let isMatching;
      if (selectedOrganizationData?.length) {
        isMatching = selectedOrganizationData.every((selectedItem) =>
          trackingData.some(
            (trackingItem) =>
              Number(selectedItem.organization_details.org_id) ===
              Number(trackingItem.organization_details.org_id),
          ),
        );
      } else {
        isMatching = selectedProspectData.every((selectedItem) =>
          trackingData.some(
            (trackingItem) =>
              Number(selectedItem.people_details.person_id) ===
              Number(trackingItem.people_details.person_id),
          ),
        );
      }

      setDisableTracking(isMatching);
    }
  }, [trackingData, selectedProspectData, selectedOrganizationData]);
  React.useEffect(() => {
    if (addToFav == true) {
      if (!selectedProspectData?.length && !selectedOrganizationData?.length) {
        toast.error("Please select records to remove from Favorites");
        setAddToFav(false);
        return;
      }
      setRemoveFavModal(true);
      setAddToFav(false);
      // handleTrackRecords()
    }
  }, [addToFav]);

  const handleRemoveMultipleFavorites = () => {
    setLoading(true);
    let data;
    if (selectedProspectData?.length) {
      data = selectedProspectData?.map((i) => i?.people_details?.person_id);
    } else {
      data = selectedOrganizationData?.map(
        (i) => i?.organization_details?.org_id,
      );
    }
    const option = {
      method: "DELETE",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/favorites/${
        selectedProspectData?.length
          ? "delete_favorites_people"
          : "delete_favorites_org"
      }?user_id=${loggedInUserId}&list_id=${openRowId}`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        toast.success("Records removed from favorites");
        setIsDeleteRecord(true);
        setIsDeleteRecordOrg(true);
        setRemoveFavModal(false);
        setSelectedOrganizationData([]);
        setSelectedProspectData([]);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const validateSalesforce = () => {
    if (!selectedProspectData || selectedProspectData?.length === 0) {
      toast.error("Please Select Records For Push To Salesforce");
      return false;
    }
    return true;
  };
  React.useEffect(() => {
    if (isSalesForceTrigger) {
      if (!validateSalesforce()) return;
      setMessageModalSalesforce(true);
    }
  }, [isSalesForceTrigger]);
  useEffect(() => {}, [selectedProspectData]);
  React.useEffect(() => {
    if (selectedProspectData?.length) {
      const data = selectedProspectData?.filter(
        (item) => item?.people_details?.suspect_status !== null,
      );
      if (data?.length) {
        setShowSalesForce("disable");
      } else {
        setShowSalesForce("show");
      }
    } else {
      setShowSalesForce(false);
    }
  }, [selectedProspectData]);

  const [successModel, setSuccessModel] = useState("");
  const handleListExport = () => {
    setLoading(true);

    const organizationIds =
      selectedOrganizationList?.map((item) => item.id) || [];
    const prospectIds = selectedProspectList?.map((item) => item.id) || [];
    const data = [...organizationIds, ...prospectIds];

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data,
      url: `${APIDataUrl()}/v1/get_lists_records`,
    };

    axios(option)
      .then((response) => {
        const fullList = response?.data || [];

        if (!fullList.length) {
          toast.error("No data received from server");
          return;
        }

        const exportData = fullList.map((i) => ({
          ...i?.organization_details,
          ...i?.people_details,
          ...i?.user_favourite_list,
        }));

        exportToExcelList(exportData, "favoritelist_exported_data");
        setIsDecisionMakerExcelList(false);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Export error:", error);
        toast.error("Something went wrong while exporting data.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const exportToExcelList = (data, filename) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${filename}.xlsx`);
  };

  const handelselectdata = () => {
    setshowSearchdata(false);
    if (activeSearch === "organization") {
      setSearchResultPeople(false);
      setSearchResultOrganization(true);
    } else if (activeSearchPeople === "people") {
      setSearchResultPeople(true);
      setSearchResultOrganization(false);
    } else {
      setSearchResultPeople(false);
      setSearchResultOrganization(false);
      // setheaderSearchData("")
      // setheaderSearchDataPeople("")
    }
  };
  const handleOrganizationsearch = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      // data: { search_term: headerSearchData },
      url: `${APIDataUrl()}/v1/search_favourites_org?search_term=${headerSearchData}&skip=0&limit=100`,
    };
    axios(option)
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          setshowSearchdata(true);
          const sortedOrgData = response?.data.org?.sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
          );
          setResponseData(sortedOrgData);
          setFavoriteSearchData(sortedOrgData);
          // setShowSearchdata(false)
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response?.data?.message);
      });
  };

  const handlePeoplesearch = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/search_favourites_people?search_term=${headerSearchDataPeople}&skip=0&limit=100`,
    };
    axios(option)
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          setshowSearchdata(true);
          const sortedOrgData = response?.data?.people.sort((a, b) =>
            a.first_name
              .toLowerCase()
              .localeCompare(b.first_name.toLowerCase()),
          );
          setResponseData(sortedOrgData);
          setFavoriteSearchData(sortedOrgData);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response?.data?.message);
      });
  };

  const [outerCreateNewListOrg, setOuterCreateNewListOrg] = useState(false);
  const [outerCreateNewListPeople, setOuterCreateNewListPeople] =
    useState(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };

  return (
    <>
      <Layout>
        {/* {loading && <Loader />} */}
        <div className="child-section-of-everypage">
          <div style={{ display: "flex" }}>
            <AiLeadsAction
              setRetrieveData={setRetrieveData}
              activeList={activeList}
              setActiveList={setActiveList}
              activeSearch={activeSearch}
              // setActiveSearch={setActiveSearch}
              setLoading={setLoading}
              loading={loading}
              setSearchResultOrganization={setSearchResultOrganization}
              setSearchResultPeople={setSearchResultPeople}
              searchResultOrganization={searchResultOrganization}
              setFavoriteSearchData={setFavoriteSearchData}
              searchResultPeople={searchResultPeople}
              setShareRecord={setShareRecord}
              setIsDecisionMakerExcel={setIsDecisionMakerExcel}
              favoriteListMenuShow={favoriteListMenuShow}
              setRequestUpdateRecord={setRequestUpdateRecord}
              setDisableRequestUpdate={setDisableRequestUpdate}
              setTrackRecord={setTrackRecord}
              setDisableTracking={setDisableTracking}
              setAddToFav={setAddToFav}
              setArchiveRecord={setArchiveRecord}
              showSalesForce={showSalesForce}
              setIsSalesForceTrigger={setIsSalesForceTrigger}
              isSalesForceTrigger={isSalesForceTrigger}
              selectedOrganizationList={selectedOrganizationList}
              handleListExport={handleListExport}
              isDecisionMakerExcelList={isDecisionMakerExcelList}
              selectedProspectList={selectedProspectList}
              selectedOrganizationData={selectedOrganizationData}
              selectedProspectData={selectedProspectData}
              setheaderSearchData={setheaderSearchData}
              setheaderSearchDataPeople={setheaderSearchDataPeople}
            />
          </div>
          {searchResultOrganization ? (
            <>
              <div
                style={{
                  display: "flex",
                  zIndex: 999,
                  padding: "90px 0px 10px 0px",
                }}
              >
                <p style={{ fontSize: "16px", fontWeight: "700" }}>My List</p>
              </div>
              <OrganizationPeopleSearch
                trackingData={trackingData}
                loading={loading}
                setLoading={setLoading}
                isSalesForceTrigger={isSalesForceTrigger}
                setIsSalesForceTrigger={setIsSalesForceTrigger}
                isDecisionMakerExcel={isDecisionMakerExcel}
                setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                archiveRecord={archiveRecord}
                setArchiveRecord={setArchiveRecord}
                trackRecord={trackRecord}
                setTrackRecord={setTrackRecord}
                selectedOuterRows={selectedLeads}
                setSelectedOuterRows={setSelectedLeads}
                setShowSalesForce={setShowSalesForce}
                showLeadsProspects={showLeadsProspects}
                selectedRows={selectedProspectsInner}
                setSelectedRows={setSelectedProspectsInner}
                totalCount={totalCount}
                setTotalCount={setTotalCount}
                addToFav={addToFav}
                setAddToFav={setAddToFav}
                favoriteSearchData={favoriteSearchData}
                searchResultPeople={searchResultPeople}
                openRowId={openRowId}
                setopenRowId={setopenRowId}
                disableOrganizationData={disableOrganizationData}
                selectedOrganizationData={selectedOrganizationData}
                setSelectedOrganizationData={setSelectedOrganizationData}
                searchResultOrganization={searchResultOrganization}
                handleOrganizationsearch={handleOrganizationsearch}
                handlePeoplesearch={handlePeoplesearch}
                headerSearchDataPeople={headerSearchDataPeople}
              />
              <div
                style={{
                  display: "flex",
                  zIndex: 999,
                  padding: "90px 0px 10px 0px",
                }}
              >
                <p style={{ fontSize: "16px", fontWeight: "700" }}>
                  Shared List
                </p>
              </div>
              <OrganizationPeopleSearchShared
                trackingData={trackingData}
                loading={loading}
                setLoading={setLoading}
                isSalesForceTrigger={isSalesForceTrigger}
                setIsSalesForceTrigger={setIsSalesForceTrigger}
                isDecisionMakerExcel={isDecisionMakerExcel}
                setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                archiveRecord={archiveRecord}
                setArchiveRecord={setArchiveRecord}
                trackRecord={trackRecord}
                setTrackRecord={setTrackRecord}
                selectedOuterRows={selectedLeads}
                setSelectedOuterRows={setSelectedLeads}
                setShowSalesForce={setShowSalesForce}
                showLeadsProspects={showLeadsProspects}
                selectedRows={selectedProspectsInner}
                setSelectedRows={setSelectedProspectsInner}
                totalCount={totalCount}
                setTotalCount={setTotalCount}
                addToFav={addToFav}
                setAddToFav={setAddToFav}
                favoriteSearchData={favoriteSearchData}
                searchResultPeople={searchResultPeople}
                openRowId={openRowId}
                setopenRowId={setopenRowId}
                disableOrganizationData={disableOrganizationData}
                selectedOrganizationData={selectedOrganizationData}
                handleOrganizationsearch={handleOrganizationsearch}
                handlePeoplesearch={handlePeoplesearch}
                headerSearchDataPeople={headerSearchDataPeople}
              />
            </>
          ) : searchResultPeople ? (
            <>
              <div
                style={{
                  display: "flex",
                  zIndex: 999,
                  padding: "90px 0px 10px 0px",
                }}
              >
                <p style={{ fontSize: "16px", fontWeight: "700" }}>My List</p>
              </div>
              <OrganizationPeopleSearchNew
                trackingData={trackingData}
                loading={loading}
                setLoading={setLoading}
                isSalesForceTrigger={isSalesForceTrigger}
                setIsSalesForceTrigger={setIsSalesForceTrigger}
                isDecisionMakerExcel={isDecisionMakerExcel}
                setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                archiveRecord={archiveRecord}
                setArchiveRecord={setArchiveRecord}
                trackRecord={trackRecord}
                setTrackRecord={setTrackRecord}
                selectedOuterRows={selectedLeads}
                setSelectedOuterRows={setSelectedLeads}
                setShowSalesForce={setShowSalesForce}
                showLeadsProspects={showLeadsProspects}
                selectedRows={selectedProspectsInner}
                setSelectedRows={setSelectedProspectsInner}
                totalCount={totalCount}
                setTotalCount={setTotalCount}
                addToFav={addToFav}
                setAddToFav={setAddToFav}
                favoriteSearchData={favoriteSearchData}
                searchResultPeople={searchResultPeople}
                disableOrganizationData={disableProspectData}
                selectedOrganizationData={selectedProspectData}
                setSelectedOrganizationData={setSelectedProspectData}
                innerDataNew={innerDataNew}
                setInnerDataNew={setInnerDataNew}
                openRowId={openRowId}
                setopenRowId={setopenRowId}
                handleOrganizationsearch={handleOrganizationsearch}
                handlePeoplesearch={handlePeoplesearch}
                headerSearchDataPeople={headerSearchDataPeople}
              />
              <div
                style={{
                  display: "flex",
                  zIndex: 999,
                  padding: "90px 0px 10px 0px",
                }}
              >
                <p style={{ fontSize: "16px", fontWeight: "700" }}>
                  Shared List
                </p>
              </div>
              <OrganizationPeopleSearchSharedNew
                trackingData={trackingData}
                loading={loading}
                setLoading={setLoading}
                isSalesForceTrigger={isSalesForceTrigger}
                setIsSalesForceTrigger={setIsSalesForceTrigger}
                isDecisionMakerExcel={isDecisionMakerExcel}
                setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                archiveRecord={archiveRecord}
                setArchiveRecord={setArchiveRecord}
                trackRecord={trackRecord}
                setTrackRecord={setTrackRecord}
                selectedOuterRows={selectedLeads}
                setSelectedOuterRows={setSelectedLeads}
                setShowSalesForce={setShowSalesForce}
                showLeadsProspects={showLeadsProspects}
                selectedRows={selectedProspectsInner}
                setSelectedRows={setSelectedProspectsInner}
                totalCount={totalCount}
                setTotalCount={setTotalCount}
                addToFav={addToFav}
                setAddToFav={setAddToFav}
                favoriteSearchData={favoriteSearchData}
                searchResultPeople={searchResultPeople}
                disableOrganizationData={disableProspectData}
                selectedOrganizationData={selectedProspectData}
                setSelectedOrganizationData={setSelectedProspectData}
                innerDataNew={innerDataNew}
                setInnerDataNew={setInnerDataNew}
                openRowId={openRowId}
                setopenRowId={setopenRowId}
                handleOrganizationsearch={handleOrganizationsearch}
                handlePeoplesearch={handlePeoplesearch}
                headerSearchDataPeople={headerSearchDataPeople}
              />
            </>
          ) : (
            <>
              {activeList === "myList" ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      zIndex: 999,
                      padding: "90px 0px 10px 0px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "700",
                      }}
                    >
                      Organizations
                    </p>
                  </div>
                  <OrganizationList


                    outerCreateNewListOrg={outerCreateNewListOrg}
                    setOuterCreateNewListOrg={setOuterCreateNewListOrg}
                    setLoading={setLoading}
                    setSelectedOuterRows={setSelectedLeads}
                    selectedOuterRows={selectedLeads}
                    showLeadsProspects={showLeadsProspects}
                    selectedRows={selectedProspectsInner}
                    setSelectedRows={setSelectedProspectsInner}
                    retrieveData={retrieveData}
                    setSearchResultPeople={setSearchResultPeople}
                    setSearchResultOrganization={setSearchResultOrganization}
                    selectedOrganizationList={selectedOrganizationList}
                    setSelectedOrganizationList={setSelectedOrganizationList}
                    selectedOrganizationData={selectedOrganizationData}
                    setSelectedOrganizationData={setSelectedOrganizationData}
                    disableOrganizationList={disableOrganizationList}
                    disableOrganizationData={disableOrganizationData}
                    isDeleteRecordOrg={isDeleteRecordOrg}
                    openRowId={openRowId}
                    setopenRowId={setopenRowId}
                    setFavoriteSearchData={setFavoriteSearchData}
                    activeSearch={activeSearch}
                    setRetrieveData={setRetrieveData}
                    searchResultPeople={searchResultPeople}
                    handelselectdata={handelselectdata}
                    showSearchdata={showSearchdata}
                    setshowSearchdata={setshowSearchdata}
                    headerSearchData={headerSearchData}
                    setheaderSearchData={setheaderSearchData}
                    handleOrganizationsearch={handleOrganizationsearch}
                    handlePeoplesearch={handlePeoplesearch}
                    responseData={responseData}
                    setResponseData={setResponseData}
                  />
                  <div
                    style={{
                      display: "flex",
                      zIndex: 999,
                      padding: "20px 0px 10px 0px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "700",
                      }}
                    >
                      People
                    </p>
                  </div>
                  <PeopleList


                    outerCreateNewListPeople={outerCreateNewListPeople}
                    setOuterCreateNewListPeople={setOuterCreateNewListPeople}
                    setLoading={setLoading}
                    setSelectedOuterRows={setSelectedLeads}
                    selectedOuterRows={selectedLeads}
                    showLeadsProspects={showLeadsProspects}
                    selectedRows={selectedProspectsInner}
                    setSelectedRows={setSelectedProspectsInner}
                    retrieveData={retrieveData}
                    setSearchResultPeople={setSearchResultPeople}
                    setSearchResultOrganization={setSearchResultOrganization}
                    selectedOrganizationList={selectedProspectList}
                    setSelectedOrganizationList={setSelectedProspectList}
                    selectedOrganizationData={selectedProspectData}
                    setSelectedOrganizationData={setSelectedProspectData}
                    disableOrganizationList={disableProspectList}
                    disableOrganizationData={disableProspectData}
                    isDeleteRecord={isDeleteRecord}
                    innerDataNew={innerDataNew}
                    setInnerDataNew={setInnerDataNew}
                    openRowId={openRowId}
                    setopenRowId={setopenRowId}
                    activeSearchPeople={activeSearchPeople}
                    setFavoriteSearchData={setFavoriteSearchData}
                    setRetrieveData={setRetrieveData}
                    handelselectdata={handelselectdata}
                    showSearchdata={showSearchdata}
                    setshowSearchdata={setshowSearchdata}
                    headerSearchDataPeople={headerSearchDataPeople}
                    setheaderSearchDataPeople={setheaderSearchDataPeople}
                    handleOrganizationsearch={handleOrganizationsearch}
                    handlePeoplesearch={handlePeoplesearch}
                    responseData={responseData}
                    setResponseData={setResponseData}
                  />
                </>
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      zIndex: 999,
                      padding: "90px 0px 10px 0px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "700",
                      }}
                    >
                      Organizations
                    </p>
                  </div>
                  <SharedOrganizationList

                    setLoading={setLoading}
                    setSelectedOuterRows={setSelectedLeads}
                    selectedOuterRows={selectedLeads}
                    showLeadsProspects={showLeadsProspects}
                    selectedRows={selectedProspectsInner}
                    setSelectedRows={setSelectedProspectsInner}
                    retrieveData={retrieveData}
                    setSearchResultPeople={setSearchResultPeople}
                    setSearchResultOrganization={setSearchResultOrganization}
                    selectedOrganizationList={selectedOrganizationList}
                    setSelectedOrganizationList={setSelectedOrganizationList}
                    selectedOrganizationData={selectedOrganizationData}
                    setSelectedOrganizationData={setSelectedOrganizationData}
                    disableOrganizationList={disableOrganizationList}
                    disableOrganizationData={disableOrganizationData}
                    openRowId={openRowId}
                    setopenRowId={setopenRowId}
                    setFavoriteSearchData={setFavoriteSearchData}
                    activeSearch={activeSearch}
                    setRetrieveData={setRetrieveData}
                    searchResultPeople={searchResultPeople}
                    handelselectdata={handelselectdata}
                    showSearchdata={showSearchdata}
                    setshowSearchdata={setshowSearchdata}
                    headerSearchData={headerSearchData}
                    setheaderSearchData={setheaderSearchData}
                    handleOrganizationsearch={handleOrganizationsearch}
                    handlePeoplesearch={handlePeoplesearch}
                    responseData={responseData}
                    setResponseData={setResponseData}

                  />
                  <div
                    style={{
                      display: "flex",
                      zIndex: 999,
                      padding: "20px 0px 10px 0px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "700",
                      }}
                    >
                      People
                    </p>
                  </div>
                  <SharedPeopleList

                    setLoading={setLoading}
                    setSelectedOuterRows={setSelectedLeads}
                    selectedOuterRows={selectedLeads}
                    showLeadsProspects={showLeadsProspects}
                    selectedRows={selectedProspectsInner}
                    setSelectedRows={setSelectedProspectsInner}
                    retrieveData={retrieveData}
                    setSearchResultPeople={setSearchResultPeople}
                    setSearchResultOrganization={setSearchResultOrganization}
                    selectedOrganizationList={selectedProspectList}
                    setSelectedOrganizationList={setSelectedProspectList}
                    selectedOrganizationData={selectedProspectData}
                    setSelectedOrganizationData={setSelectedProspectData}
                    disableOrganizationList={disableProspectList}
                    disableOrganizationData={disableProspectData}
                    innerDataNew={innerDataNew}
                    setInnerDataNew={setInnerDataNew}
                    openRowId={openRowId}
                    setopenRowId={setopenRowId}
                    activeSearchPeople={activeSearchPeople}
                    setFavoriteSearchData={setFavoriteSearchData}
                    setRetrieveData={setRetrieveData}
                    handelselectdata={handelselectdata}
                    showSearchdata={showSearchdata}
                    setshowSearchdata={setshowSearchdata}
                    headerSearchDataPeople={headerSearchDataPeople}
                    setheaderSearchDataPeople={setheaderSearchDataPeople}
                    handleOrganizationsearch={handleOrganizationsearch}
                    responseData={responseData}
                    setResponseData={setResponseData}
                    handlePeoplesearch={handlePeoplesearch}
                    isDeleteRecord={isDeleteRecord}

                  />
                </>
              )}
            </>
          )}
        </div>
      </Layout>
      <MessageModal
        open={archiveMessageModal}
        setOpen={setArchiveMessageModal}
        message={
          selectedOrganizationData?.length > 0
            ? `Are you sure that you want to archive ${
                selectedOrganizationData?.length > 1
                  ? "these organizations"
                  : "this organization"
              }?`
            : `Are you sure that you want to archive ${
                selectedProspectData?.length > 1
                  ? "these Prospects"
                  : "this Prospect"
              } ?`
        }
        handleSubmit={handleArchiveRecords}
        length={
          selectedOrganizationData?.length > 0
            ? selectedOrganizationData?.length
            : selectedProspectData?.length
        }
      />

      <MessageModal
        open={messageModalTrack}
        setOpen={setMessageModalTrack}
        message={
          selectedOrganizationData?.length > 0
            ? `Are you sure that you want to add ${
                selectedOrganizationData?.length > 1
                  ? "these organizations"
                  : "this organization"
              } to tracking ? `
            : `Are you sure that you want to add ${
                selectedProspectData?.length > 1
                  ? "these Prospects"
                  : "this Prospect"
              } to tracking ? `
        }
        handleSubmit={handleTrackRecords}
        length={
          selectedOrganizationData?.length > 0
            ? selectedOrganizationData?.length
            : selectedProspectData?.length
        }
      />

      <SalesForceMessageModal
        open={messageModalSalesforce}
        setOpen={setMessageModalSalesforce}
        selectedOuterRows={selectedProspectData?.map(
          (item) => item?.people_details,
        )}
        setSelectedOuterRows={setSelectedProspectData}
        setIsSalesForceTrigger={setIsSalesForceTrigger}
        decisionMakerData={innerDataNew}
        setLoading={setLoading}
      />

      <MessageModal
        open={removeFavModal}
        setOpen={setRemoveFavModal}
        message={
          selectedOrganizationData?.length > 0
            ? `Are you sure you want to remove ${
                selectedOrganizationData?.length > 1
                  ? "these record(s)"
                  : "this record"
              } from the list ? `
            : `Are you sure you want to remove ${
                selectedProspectData?.length > 1
                  ? "these record(s)"
                  : "this record"
              } from the list ? `
        }
        handleSubmit={handleRemoveMultipleFavorites}
        length={
          selectedOrganizationData?.length > 0
            ? selectedOrganizationData?.length
            : selectedProspectData?.length
        }
      />
      {selectedProspectData?.length == 1 ? (
        <ProspectRequestModal
          requestUpdateRecord={requestUpdateModal}
          setRequestUpdateRecord={setRequestUpdateModal}
          profileData={selectedProspectData[0]?.people_details}
          strengthData={selectedProspectData[0]?.strengthData}
          peopleId={selectedProspectData?.[0]?.people_details?.person_id}
          setSuccessModel={setSuccessModel}
          innerDataNew={innerDataNew}
          successModel={successModel}
          setSelectedOuterRows={setSelectedProspectData}
        />
      ) : null}
      {selectedOrganizationData?.length == 1 ? (
        <LeadsProspectModal
          requestUpdateRecord={requestUpdateModal}
          setRequestUpdateRecord={setRequestUpdateModal}
          setSuccessModel={setSuccessModel}
          successModel={successModel}
          profileData={selectedOrganizationData[0]?.organization_details}
          peopleId={selectedOrganizationData?.[0]?.organization_details?.org_id}
          setSelectedOuterRows={setSelectedOrganizationData}
        />
      ) : null}

      <Modal
        open={successModel == true}
        onClose={() => setSuccessModel(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style} style={{ overflowY: "auto", width: "30%" }}>
            <div className="de_pad_req-up">
              <p className="cross-people-req-model">
                <ClearIcon onClick={() => setSuccessModel(false)} />
              </p>
              <p className="de_head">
                Your Record Update request has been successfully submitted. The
                Orbit Team will review your request and notify you when the record
                has been updated.
              </p>
            </div>
          </Box>
        </div>
      </Modal>
    </>
  );
};
export default FavoritesList;
